import 'bootstrap/js/dist/collapse.js';
import 'bootstrap/js/dist/modal.js';
import $ from 'jquery';
import LoadingIndicator from '../../js/ui/LoadingIndicator.mjs';
import {CammioApplicationForm} from '../../js/forms/CammioApplicationForm.mjs';

(async () => {
  const $modal = $('#modal-job-posting-cammioApplicationForm');
  const $holder = $('#modal-job-posting-cammioApplicationForm-holder');
  const targetUrl = $(`[data-target="#${$modal.attr('id')}"]`).attr('href') || '';

  // Handle events
  $modal.on('show.bs.modal', () => {
    LoadingIndicator.show();
    loadCammioApplicationForm(targetUrl);
  });
  $modal.on('hidden.bs.modal', () => {
    $holder.collapse('hide');
  });

  function loadCammioApplicationForm(url) {
    $.ajax({
      url,
      success: async (data) => {
        const $data = $(data);
        await initCammioApplicationForm($data);
        $holder.collapse('show');
        LoadingIndicator.hide();
      },
    });
  }

  async function initCammioApplicationForm($data) {
    return new Promise((resolve) => {
      const $formWrapper = $data.find('.ef-job-application-form');

      // Insert the form into the modal
      $holder.html($formWrapper);

      // Restructure the form
      $formWrapper.find('.offset-md-2').removeClass('offset-md-2 col-md-8 offset-lg-3 col-lg-6');

      // Hard reveal elements
      $holder.find('.reveal').removeClass('reveal');

      const cammioApplicationForm = new CammioApplicationForm({
        $form: $formWrapper.find('form'),
      });

      // Override scrollToErrorMessage
      cammioApplicationForm.scrollToErrorMessage = () => {
        const $errorMessages = $('.form-alert, .has-error');
        if ($errorMessages.length) {
          $modal.animate({
            scrollTop: $errorMessages.first().get(0).offsetTop,
          }, 1000);
        }
      }

      // Override submit with ajax loading
      cammioApplicationForm.doSubmit = (event) => {
        event.preventDefault();
        LoadingIndicator.show();

        const $form = cammioApplicationForm.$form;
        const url = $form.attr('action');
        const formData = $form.serialize();

        $.ajax({
          url,
          type: 'POST',
          data: formData,
          success: async (data) => {
            const $data = $(data);
            const cammioInterviewUrl = $data.find('[data-cammio-interview-url]').attr('data-cammio-interview-url') || '';

            if (cammioInterviewUrl) {
              const $modalBody = $holder.parent();
              // Inject result
              $modalBody.html($data.find('[data-cammio-interview-url]'));

              // Hard reveal elements
              $modalBody.find('.reveal').removeClass('reveal');

              // Redirect to the Cammio interview
              setTimeout(() => {
                window.location.href = cammioInterviewUrl;
              }, 5000);
            } else {
              await initCammioApplicationForm($data);
            }
            LoadingIndicator.hide();
          },
        });
      };

      resolve();
    });
  }
})();
